import { CANVAS_ALIGNMENT_INLINE, CANVAS_ALIGNMENT_LEFT, CANVAS_ALIGNMENT_CENTER, CANVAS_ALIGNMENT_RIGHT, CANVAS_VERTICAL_ALIGNMENT_BOTTOM, CANVAS_VERTICAL_ALIGNMENT_MIDDLE, CANVAS_VERTICAL_ALIGNMENT_TOP, CANVAS_ROTATION, CANVAS_ALIGNMENT_FULL_WIDTH, CANVAS_DIMENSIONS, CANVAS_MARGINS, CANVAS_FILL_COLOR, CANVAS_BULLETED_LIST, CANVAS_BULLETED_LIST_BUTTON, CANVAS_NUMBERED_LIST, CANVAS_NUMBERED_LIST_BUTTON, CANVAS_LINEHEIGHT, CANVAS_OUTDENT, CANVAS_INDENT, CANVAS_LINK, CANVAS_ICON_TYPE, CANVAS_ALIGNMENT_DROPDOWN, CANVAS_VERTICAL_ALIGNMENT_DROPDOWN, CANVAS_BORDER_COLOR, CANVAS_TABLE_STYLES, CANVAS_TABLE_CELL_STYLES } from './toolbar';
const DividerControl = {
  type: 'DIVIDER'
};
const IndentationControls = [{
  type: 'BUTTON',
  control: CANVAS_OUTDENT,
  priority: 3
}, {
  type: 'BUTTON',
  control: CANVAS_INDENT,
  priority: 3
}];
const AlignmentControls = [{
  type: 'BUTTON',
  control: CANVAS_ALIGNMENT_INLINE,
  priority: 1
}, {
  type: 'BUTTON',
  control: CANVAS_ALIGNMENT_LEFT,
  priority: 1
}, {
  type: 'BUTTON',
  control: CANVAS_ALIGNMENT_CENTER,
  priority: 1
}, {
  type: 'BUTTON',
  control: CANVAS_ALIGNMENT_RIGHT,
  priority: 1
}, {
  type: 'BUTTON',
  control: CANVAS_ALIGNMENT_FULL_WIDTH,
  priority: 1
}];
const AlignmentDropdownControl = {
  type: 'BUTTON',
  control: CANVAS_ALIGNMENT_DROPDOWN,
  menuItems: []
};
const VerticalAlignmentControls = [{
  type: 'BUTTON',
  control: CANVAS_VERTICAL_ALIGNMENT_BOTTOM,
  priority: 1
}, {
  type: 'BUTTON',
  control: CANVAS_VERTICAL_ALIGNMENT_MIDDLE,
  priority: 1
}, {
  type: 'BUTTON',
  control: CANVAS_VERTICAL_ALIGNMENT_TOP,
  priority: 1
}];
const VerticalAlignmentDropdownControl = {
  type: 'BUTTON',
  control: CANVAS_VERTICAL_ALIGNMENT_DROPDOWN,
  menuItems: []
};
const DimensionControls = [{
  type: 'BUTTON',
  control: CANVAS_DIMENSIONS
}];
const MarginControls = [{
  type: 'BUTTON',
  control: CANVAS_MARGINS
}];
const FillColorControl = {
  type: 'BUTTON',
  control: CANVAS_FILL_COLOR
};

/** CTA */
export const getCtaContextualToolbar = () => [{
  controls: [{
    type: 'BUTTON',
    control: CANVAS_BULLETED_LIST
  }, {
    type: 'BUTTON',
    control: CANVAS_NUMBERED_LIST
  }, ...IndentationControls]
}, {
  controls: [DividerControl]
}, {
  controls: AlignmentControls.slice(0, AlignmentControls.length - 1)
}];

/** IMAGE */
export const getImageContextualToolbar = ({
  useListButtons = false,
  showLineHeight = true,
  showMarginControls = true
} = {}) => {
  const formatControls = [{
    type: 'BUTTON',
    control: useListButtons ? CANVAS_BULLETED_LIST_BUTTON : CANVAS_BULLETED_LIST,
    priority: 1
  }, {
    type: 'BUTTON',
    control: useListButtons ? CANVAS_NUMBERED_LIST_BUTTON : CANVAS_NUMBERED_LIST,
    priority: 1
  }];
  if (showLineHeight) {
    formatControls.push({
      type: 'BUTTON',
      control: CANVAS_LINEHEIGHT,
      priority: 2
    });
  }
  formatControls.push(...IndentationControls);
  formatControls.push({
    type: 'MORE_MENU',
    menuItems: []
  });
  const imageTopRow = [{
    controls: formatControls,
    responsivePriority: 0,
    boundary: 0
  }, {
    controls: [DividerControl]
  }, {
    controls: [...AlignmentControls.slice(0, AlignmentControls.length - 1), AlignmentDropdownControl],
    responsivePriority: 1,
    boundary: 0
  }, {
    controls: [DividerControl]
  }, {
    controls: [{
      type: 'BUTTON',
      control: CANVAS_LINK
    }]
  }];
  const imageBottomRow = [{
    controls: DimensionControls
  }];
  if (showMarginControls) {
    imageBottomRow.push({
      controls: [DividerControl],
      multiRowResponsive: true
    }, {
      controls: MarginControls,
      multiRowResponsive: true
    });
  }
  return [imageTopRow, imageBottomRow];
};

/** VIDEO */
export const getVideoContextualToolbar = ({
  showAlignmentControls = true,
  showFullWidthControl = true,
  showMarginControls = true
} = {}) => {
  let alignmentControls = [];
  // Omit the necessary alignment controls
  const startIdx = showAlignmentControls ? 0 : AlignmentControls.length - 1;
  const endIdx = AlignmentControls.length - (showFullWidthControl ? 0 : 1);
  alignmentControls = AlignmentControls.slice(startIdx, endIdx);
  const videoTopRow = [{
    controls: [FillColorControl]
  }];
  if (alignmentControls.length) {
    videoTopRow.push({
      controls: [DividerControl]
    }, {
      controls: [...alignmentControls, AlignmentDropdownControl],
      responsivePriority: 0,
      boundary: 0
    });
  }
  const videoBottomRow = [{
    controls: DimensionControls
  }];
  if (showMarginControls) {
    videoBottomRow.push({
      controls: [DividerControl],
      multiRowResponsive: true
    }, {
      controls: MarginControls,
      multiRowResponsive: true
    });
  }
  return [videoTopRow, videoBottomRow];
};

/** EMBED */
export const getEmbedContextualToolbar = ({
  showAlignmentControls = true,
  showMarginControls = true
} = {}) => {
  let alignmentControls = [];
  // Potentially omit ALL non-fullwidth controls
  const startIdx = showAlignmentControls ? 0 : AlignmentControls.length - 1;
  alignmentControls = AlignmentControls.slice(startIdx);
  const embedTopRow = [{
    controls: [...alignmentControls, AlignmentDropdownControl],
    responsivePriority: 0,
    boundary: 0
  }];
  const embedBottomRow = [{
    controls: DimensionControls
  }];
  if (showMarginControls) {
    embedBottomRow.push({
      controls: [DividerControl],
      multiRowResponsive: true
    }, {
      controls: MarginControls,
      multiRowResponsive: true
    });
  }
  return [embedTopRow, embedBottomRow];
};

/** ICON */
export const getIconContextualToolbar = () => {
  const iconTopRow = [{
    controls: [FillColorControl, ...IndentationControls]
  }, {
    controls: [DividerControl]
  }, {
    controls: [...VerticalAlignmentControls, VerticalAlignmentDropdownControl],
    responsivePriority: 0,
    boundary: 0
  }, {
    controls: [DividerControl]
  }, {
    controls: [{
      type: 'BUTTON',
      control: CANVAS_LINK
    }]
  }];
  const iconBottomRow = [{
    controls: DimensionControls
  }, {
    controls: [DividerControl],
    multiRowResponsive: true
  }, {
    controls: [{
      type: 'BUTTON',
      control: CANVAS_ROTATION,
      priority: 1
    }, {
      type: 'BUTTON',
      control: CANVAS_ICON_TYPE,
      priority: 2
    }, {
      type: 'MORE_MENU',
      menuItems: []
    }],
    responsivePriority: 1,
    boundary: 0,
    multiRowResponsive: true
  }];
  return [iconTopRow, iconBottomRow];
};

/** TABLE */
export const getTableContextualToolbar = ({
  showMarginControls = true
} = {}) => {
  const alignmentControls = AlignmentControls.slice(0, AlignmentControls.length - 1);
  const tableTopRow = [{
    controls: [...alignmentControls, AlignmentDropdownControl],
    responsivePriority: 0,
    boundary: 0
  }];
  let tableControls;
  if (showMarginControls) {
    // Add MarginControls and DividerControl before CANVAS_TABLE_STYLES
    tableControls = [{
      controls: [{
        type: 'BUTTON',
        control: CANVAS_BORDER_COLOR
      }, ...MarginControls],
      multiRowResponsive: true
    }, {
      controls: [DividerControl],
      multiRowResponsive: true
    }, {
      controls: [{
        type: 'BUTTON',
        control: CANVAS_TABLE_STYLES
      }],
      multiRowResponsive: true
    }];
  } else {
    tableControls = [{
      controls: [{
        type: 'BUTTON',
        control: CANVAS_BORDER_COLOR
      }, {
        type: 'BUTTON',
        control: CANVAS_TABLE_STYLES
      }],
      multiRowResponsive: true
    }];
  }
  const tableBottomRow = [{
    controls: DimensionControls
  }, {
    controls: [DividerControl],
    multiRowResponsive: true
  }, ...tableControls];
  return [tableTopRow, tableBottomRow];
};

/** TABLE CELL */
export const getTableCellContextualToolbar = ({
  canvasToolbar,
  showCellColorControls = true
}) => {
  const colorControls = [];
  if (showCellColorControls) {
    colorControls.push({
      type: 'BUTTON',
      control: CANVAS_FILL_COLOR
    }, {
      type: 'BUTTON',
      control: CANVAS_BORDER_COLOR
    });
  }
  const tableCellRow = [{
    controls: [...colorControls, Object.assign({}, VerticalAlignmentDropdownControl, {
      menuItems: [CANVAS_VERTICAL_ALIGNMENT_TOP, CANVAS_VERTICAL_ALIGNMENT_MIDDLE, CANVAS_VERTICAL_ALIGNMENT_BOTTOM]
    }), {
      type: 'BUTTON',
      control: CANVAS_TABLE_CELL_STYLES
    }]
  }];
  const hasRows = Array.isArray(canvasToolbar[0]);
  if (hasRows) {
    const topRow = canvasToolbar[0];
    const bottomRow = canvasToolbar[1];
    return [topRow, [...bottomRow, {
      controls: [DividerControl]
    }, ...tableCellRow]];
  } else {
    return [...canvasToolbar, {
      controls: [DividerControl]
    }, ...tableCellRow];
  }
};